export const CHALLENGE_CALL_SUCCESS = 'CHALLENGE_CALL_SUCCESS';
export const CHALLENGE_CALL_LOADING = 'CHALLENGE_CALL_LOADING';
export const CHALLENGE_CALL_ERROR = 'CHALLENGE_CALL_ERROR';
export const RESET_CHALLENGE_DATA = 'RESET_CHALLENGE_DATA';